"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let searchBar = document.querySelector('.searchbar__input');
let searchBarDelete = document.querySelector('.searchbar__input--delete');
if (searchBar) {
    searchBar.addEventListener("keyup", (event) => {
        event.preventDefault();
        (searchBar.value !== "") ? searchBarDelete.classList.remove('hidden') : searchBarDelete.classList.add('hidden');
        searchBarDelete.addEventListener("click", (event) => {
            event.preventDefault();
            (searchBar.value) ? searchBar.value = '' : '';
            searchBarDelete.classList.add('hidden');
        });
    });
}
exports.default = {};
